//
//    WARNING
//    This file was auto-generated by swagger-typescript-codegen.
//    Please do not make changes here because they may be overwritten.
//

import request from 'superagent';
import {
  CallbackHandler,
  CommonRequestOptions,
  ConfigureAgentHandler,
  ConfigureRequestHandler,
  Logger,
  Parameter,
  ProblemDetails,
  QueryParameters,
  RequestHeaders,
  RequestHeadersHandler,
  ResponseWithBody,
} from './types';

export type Calculation = {
  parameters?: Array<Parameter>;
  allowOverwrite?: boolean;
  errorFunction?: string;
  function?: string;
  includeInResults?: boolean;
  isDisabled?: boolean;
  outputName?: string;
  outputType?: string;
};

export type Model = {
  calculations?: Array<Calculation>;
  createDate?: string;
  debugMode?: boolean;
  id?: string;
  isActive?: boolean;
  lastUpdated?: string;
  modelId?: string;
  modelInputs?: Array<Parameter>;
  name?: string;
  readOnly?: boolean;
  updatedBy?: string;
  version?: number;
};

export type ModelResponseWrapper = {
  data?: Model;
};

export type ModelSummary = {
  id?: string;
  versions?: Array<ModelVersionSummary>;
};

export type ModelSummaryArrayResponseWrapper = {
  data?: Array<ModelSummary>;
};

export type ModelVersionSummary = {
  createDate?: string;
  description?: string;
  id?: string;
  isActive?: boolean;
  lastUpdated?: string;
  modelId?: string;
  versionNumber?: number;
};

/**
 * Insight2Profit ModelService
 * @class ModelService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
export class ModelService {
  private domain: string = '';
  private errorHandlers: CallbackHandler[] = [];
  private requestHeadersHandler?: RequestHeadersHandler;
  private configureAgentHandler?: ConfigureAgentHandler;
  private configureRequestHandler?: ConfigureRequestHandler;

  constructor(domain?: string, private logger?: Logger) {
    if (domain) {
      this.domain = domain;
    }
  }

  getDomain() {
    return this.domain;
  }

  addErrorHandler(handler: CallbackHandler) {
    this.errorHandlers.push(handler);
  }

  setRequestHeadersHandler(handler: RequestHeadersHandler) {
    this.requestHeadersHandler = handler;
  }

  setConfigureAgentHandler(handler: ConfigureAgentHandler) {
    this.configureAgentHandler = handler;
  }

  setConfigureRequestHandler(handler: ConfigureRequestHandler) {
    this.configureRequestHandler = handler;
  }

  private request(
    method: string,
    url: string,
    body: any,
    headers: RequestHeaders,
    queryParameters: QueryParameters,
    form: any,
    reject: CallbackHandler,
    resolve: CallbackHandler,
    opts: CommonRequestOptions
  ) {
    if (this.logger) {
      this.logger.log(`Call ${method} ${url}`);
    }

    const agent = this.configureAgentHandler ? this.configureAgentHandler(request) : request;

    let req = agent(method, url);
    if (this.configureRequestHandler) {
      req = this.configureRequestHandler(req);
    }

    req = req.query(queryParameters);

    if (body) {
      req.send(body);

      if (typeof body === 'object' && !(body.constructor.name === 'Buffer')) {
        headers['Content-Type'] = 'application/json';
      }
    }

    headers['x-insight-ns'] = 'master';

    if (Object.keys(form).length > 0) {
      req.type('form');
      req.send(form);
    }

    if (this.requestHeadersHandler) {
      headers = this.requestHeadersHandler({
        ...headers,
      });
    }

    req.set(headers);

    if (opts.$retries && opts.$retries > 0) {
      req.retry(opts.$retries);
    }

    if ((opts.$timeout && opts.$timeout > 0) || (opts.$deadline && opts.$deadline > 0)) {
      req.timeout({
        deadline: opts.$deadline,
        response: opts.$timeout,
      });
    }

    req.end((error, response) => {
      // an error will also be emitted for a 4xx and 5xx status code
      // the error object will then have error.status and error.response fields
      // see superagent error handling: https://github.com/visionmedia/superagent/blob/master/docs/index.md#error-handling
      if (error) {
        reject(error);
        this.errorHandlers.forEach((handler) => handler(error));
      } else {
        resolve(response);
      }
    });
  }

  /**
   *
   * @method
   * @name ModelService#getModels
   * @description /ms/clients/{clientId}/models
   * @param {string} clientId - Insight2Profit ModelService
   */
  getModels(
    parameters: {
      clientId: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, ModelSummaryArrayResponseWrapper> | ResponseWithBody<400, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ms/clients/{clientId}/models';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name ModelService#deleteModelsById
   * @description /ms/clients/{clientId}/models/{id}
   * @param {string} clientId - Insight2Profit ModelService
   * @param {string} id - Insight2Profit ModelService
   */
  deleteModelsById(
    parameters: {
      clientId: string;
      id: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, void> | ResponseWithBody<400, ProblemDetails> | ResponseWithBody<404, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ms/clients/{clientId}/models/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name ModelService#getModelsById
   * @description /ms/clients/{clientId}/models/{id}
   * @param {string} clientId - Insight2Profit ModelService
   * @param {string} id - Insight2Profit ModelService
   */
  getModelsById(
    parameters: {
      clientId: string;
      id: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, ModelResponseWrapper>
    | ResponseWithBody<400, ProblemDetails>
    | ResponseWithBody<404, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ms/clients/{clientId}/models/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name ModelService#postModelsById
   * @description /ms/clients/{clientId}/models/{id}
   * @param {string} clientId - Insight2Profit ModelService
   * @param {string} id - Insight2Profit ModelService
   * @param {} body - Insight2Profit ModelService
   */
  postModelsById(
    parameters: {
      clientId: string;
      id: string;
      body?: Model;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, ModelResponseWrapper> | ResponseWithBody<400, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ms/clients/{clientId}/models/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name ModelService#putModelsById
   * @description /ms/clients/{clientId}/models/{id}
   * @param {string} clientId - Insight2Profit ModelService
   * @param {string} id - Insight2Profit ModelService
   * @param {} body - Insight2Profit ModelService
   */
  putModelsById(
    parameters: {
      clientId: string;
      id: string;
      body?: Model;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, ModelResponseWrapper>
    | ResponseWithBody<400, ProblemDetails>
    | ResponseWithBody<404, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ms/clients/{clientId}/models/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name ModelService#deleteModelsByIdVersionsByVersion
   * @description /ms/clients/{clientId}/models/{id}/versions/{version}
   * @param {string} clientId - Insight2Profit ModelService
   * @param {string} id - Insight2Profit ModelService
   * @param {integer} version - Insight2Profit ModelService
   */
  deleteModelsByIdVersionsByVersion(
    parameters: {
      clientId: string;
      id: string;
      version: number;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, void> | ResponseWithBody<400, ProblemDetails> | ResponseWithBody<404, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ms/clients/{clientId}/models/{id}/versions/{version}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{version}', `${parameters['version']}`);

      if (parameters['version'] === undefined) {
        reject(new Error('Missing required  parameter: version'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name ModelService#getModelsByIdVersionsByVersion
   * @description /ms/clients/{clientId}/models/{id}/versions/{version}
   * @param {string} clientId - Insight2Profit ModelService
   * @param {string} id - Insight2Profit ModelService
   * @param {integer} version - Insight2Profit ModelService
   */
  getModelsByIdVersionsByVersion(
    parameters: {
      clientId: string;
      id: string;
      version: number;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, ModelResponseWrapper>
    | ResponseWithBody<400, ProblemDetails>
    | ResponseWithBody<404, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ms/clients/{clientId}/models/{id}/versions/{version}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{version}', `${parameters['version']}`);

      if (parameters['version'] === undefined) {
        reject(new Error('Missing required  parameter: version'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name ModelService#postModelsByIdVersionsByVersion
   * @description /ms/clients/{clientId}/models/{id}/versions/{version}
   * @param {string} clientId - Insight2Profit ModelService
   * @param {string} id - Insight2Profit ModelService
   * @param {integer} version - Insight2Profit ModelService
   * @param {} body - Insight2Profit ModelService
   */
  postModelsByIdVersionsByVersion(
    parameters: {
      clientId: string;
      id: string;
      version: number;
      body?: Model;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, ModelResponseWrapper> | ResponseWithBody<400, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ms/clients/{clientId}/models/{id}/versions/{version}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{version}', `${parameters['version']}`);

      if (parameters['version'] === undefined) {
        reject(new Error('Missing required  parameter: version'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name ModelService#putModelsByIdVersionsByVersion
   * @description /ms/clients/{clientId}/models/{id}/versions/{version}
   * @param {string} clientId - Insight2Profit ModelService
   * @param {string} id - Insight2Profit ModelService
   * @param {integer} version - Insight2Profit ModelService
   * @param {} body - Insight2Profit ModelService
   */
  putModelsByIdVersionsByVersion(
    parameters: {
      clientId: string;
      id: string;
      version: number;
      body?: Model;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, ModelResponseWrapper>
    | ResponseWithBody<400, ProblemDetails>
    | ResponseWithBody<404, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ms/clients/{clientId}/models/{id}/versions/{version}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{version}', `${parameters['version']}`);

      if (parameters['version'] === undefined) {
        reject(new Error('Missing required  parameter: version'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name ModelService#putModelsByIdVersionsByVersionByActivate
   * @description /ms/clients/{clientId}/models/{id}/versions/{version}/{activate}
   * @param {string} clientId - Insight2Profit ModelService
   * @param {string} id - Insight2Profit ModelService
   * @param {integer} version - Insight2Profit ModelService
   * @param {boolean} activate - Insight2Profit ModelService
   */
  putModelsByIdVersionsByVersionByActivate(
    parameters: {
      clientId: string;
      id: string;
      version: number;
      activate: boolean;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, ModelResponseWrapper>
    | ResponseWithBody<400, ProblemDetails>
    | ResponseWithBody<404, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ms/clients/{clientId}/models/{id}/versions/{version}/{activate}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{version}', `${parameters['version']}`);

      if (parameters['version'] === undefined) {
        reject(new Error('Missing required  parameter: version'));
        return;
      }

      path = path.replace('{activate}', `${parameters['activate']}`);

      if (parameters['activate'] === undefined) {
        reject(new Error('Missing required  parameter: activate'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }
}

export default ModelService;
